import fetchApi, { fetchWithTimeout } from "./fetch";

export type WbSlotConfig = {
  id: number;
  enabled: boolean;
  booking_enabled: boolean;
  lat_top: number | null;
  lon_top: number | null;
  lat_end: number | null;
  lon_end: number | null;
  min_day: number;
  horizon_days: number;
  needed_per_day: number;
  poll_interval_ms: number;
  date_mismatch_ttl_hours: number;
  auto_block_ttl_hours: number;
  box_type_id: number;
  barcode: string;
  products_count: number;
  pallet_count: number | null;
};

export type WbSlotDemand = {
  date: string;
  offset: number;
  needed: number;
  booked: number;
  remaining: number;
};

export type WbSlotHealth = {
  alive: boolean;
  heartbeatAgeMs: number | null;
  session: {
    state: string;
    draftId: string | null;
    supplyId: number | null;
    warehouseId: number | null;
  } | null;
};

export type WbSlotOffer = {
  warehouseId: number;
  name: string;
  class: string;
  errors: string[];
};

const get = async <T>(path: string, timeoutMs = 8000): Promise<T> => {
  const res = await fetchWithTimeout(path, { method: "GET", timeoutMs });
  return res.json();
};

export const fetchWbSlotConfig = () => get<WbSlotConfig>("/api/wb_slots/config");
export const patchWbSlotConfig = async (body: Partial<WbSlotConfig>) => {
  const res = await fetchWithTimeout("/api/wb_slots/config", {
    method: "PATCH",
    body: JSON.stringify(body),
    timeoutMs: 8000,
  });
  return res.json() as Promise<WbSlotConfig>;
};
export const fetchWbSlotDemand = () =>
  get<WbSlotDemand[]>("/api/wb_slots/demand");
export const fetchWbSlotHealth = () =>
  get<WbSlotHealth>("/api/wb_slots/health", 5000);
export const fetchWbSlotOffers = () =>
  get<{ offers: WbSlotOffer[]; updatedAt: string | null }>(
    "/api/wb_slots/offers",
    5000
  );
export const fetchWbSlotBookings = () => get<any[]>("/api/wb_slots/bookings");
export const fetchWbSlotBlocks = () => get<any[]>("/api/wb_slots/blocks");
export const fetchWbSlotActiveSupplies = (refresh = false) =>
  get<any[]>(
    `/api/wb_slots/active_supplies${refresh ? "?refresh=1" : ""}`,
    refresh ? 8000 : 5000
  );
export const fetchWbSlotAnalytics = () => get<any>("/api/wb_slots/analytics");
export const addWbSlotBlock = async (body: {
  warehouse_id: number;
  reason?: string;
}) => {
  const res = await fetchApi("/api/wb_slots/blocks", {
    method: "POST",
    body: JSON.stringify(body),
  });
  return res.json();
};
export const deleteWbSlotBlock = async (id: number) => {
  const res = await fetchApi(`/api/wb_slots/blocks/${id}`, { method: "DELETE" });
  return res.json();
};
